import { TFunction } from 'i18next';
import { ConceptCategory } from '../../../../../models/Entities/Contracts/ConceptCategory';
import { NewConceptCategory } from '../../../../../models/Entities/Contracts/NewConceptCategory';

export interface ContractConceptCategoryFormProps {
  isOpen: boolean;
  dismissPanel: () => void;
  ConceptCategory?: ConceptCategory;
}

export interface FormValidation {
  success: boolean;
  errors: string[];
}

export interface ValidateFormInput {
  conceptCategoryName: string;
  conceptCategoryDescription: string;
}

export const validateForm = (
  input: ValidateFormInput,
  t: TFunction
): FormValidation => {
  const errors: string[] = [];

  if (!input.conceptCategoryName || input.conceptCategoryName.trim() === '') {
    errors.push(t('contractConceptCategoryForm.validation.requiredName'));
  }

  if (input.conceptCategoryName && input.conceptCategoryName.length > 200) {
    errors.push(t('contractConceptCategoryForm.validation.nameTooLong'));
  }

  if (input.conceptCategoryDescription && input.conceptCategoryDescription.length > 500) {
    errors.push(t('contractConceptCategoryForm.validation.descriptionTooLong'));
  }

  return {
    success: errors.length === 0,
    errors
  };
};

export const buildUpdatePayload = (
  current: ConceptCategory,
  conceptCategoryName: string,
  conceptCategoryDescription: string
): ConceptCategory => ({
  id: current.id,
  conceptCategoryName,
  conceptCategoryDescription
});

export const buildCreatePayload = (
  conceptCategoryName: string,
  conceptCategoryDescription: string
): NewConceptCategory => ({
  conceptCategoryName,
  conceptCategoryDescription
});
